import React from 'react';
import ScaleLoader from 'react-spinners/ScaleLoader';

// shimmer for table 
function Shimmer() {
    const loaderStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh', 
        width: '100vw',  
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1000, 
        backgroundColor: 'rgba(255, 255, 255, 0.7)' 
    };

    return (
        <div style={loaderStyle}>
            < ScaleLoader color="#135674" />
        </div>
    );
}

export default Shimmer;
